<app-card class="w-full" [class]="isGray() ? 'bg-gray-input':''">

  <div class="p-4 flex justify-between">
    <div class="facet-icon">
      @if (icon()) {
      <app-icon class="text-blue mr-2" [name]="icon() || ''"></app-icon>
      }
      <div class="flex flex-col">
        <p class="font-bold">
          <ng-content select="[title]"></ng-content>
        </p>
        <p class="text-gray">
          <ng-content select="[subtitle]"></ng-content>
        </p>
      </div>
      <ng-content select="[left]"></ng-content>
    </div>

    <div class="flex items-center">
      @if (isCheckbox()) {
      <mat-checkbox class="text-blue" [checked]="isChecked()"></mat-checkbox>
      }
      @if(isChevronIcon()) {
      <app-icon size="medium" class="text-blue" name="heroChevronRight"></app-icon>
      }
      <ng-content select="[right]"></ng-content>
    </div>
  </div>

  <ng-content select="[bottom]"></ng-content>

</app-card>

<div class="flex items-center">
  @if(isDeleteIcon()) {
  <app-icon size="medium" class="cursor-pointer text-yellow ml-2" name="heroTrash"
    (click)="onDelete($event)"></app-icon>
  }
</div>
